import React from 'react';
import { Label } from '../ui/label';
import { GROUP_PRESET_COLORS, DEFAULT_GROUP_COLOR } from './groupColors';

// Shared color picker for Group entities (Device Groups, Geofence Groups, etc.).
// Mirrors the existing GeofencingPanel ColorPickerField UI/UX (preset swatches + native color input).
// Props:
//   value     — current hex color (e.g., '#2563eb')
//   onChange  — (hex: string) => void
//   testIdPrefix — optional override (default: 'group-color')
//   label     — optional override (default: 'Color')
export const GroupColorPicker = ({
  value,
  onChange,
  testIdPrefix = 'group-color',
  label = 'Color',
  presetColors = GROUP_PRESET_COLORS,
  showCustom = true,
}) => {
  const active = value || DEFAULT_GROUP_COLOR;
  return (
    <div className="space-y-1.5" data-testid={`${testIdPrefix}-picker`}>
      {label && <Label className="text-xs">{label}</Label>}
      <div className="flex flex-wrap items-center gap-1.5">
        {presetColors.map((preset) => (
          <button
            key={preset.value}
            type="button"
            title={preset.label}
            onClick={() => onChange(preset.value)}
            className={`w-6 h-6 rounded-full shrink-0 transition-all ${active.toLowerCase() === preset.value.toLowerCase() ? 'border-[3px] border-blue-500 scale-110' : 'border-2 border-transparent hover:border-gray-400'}`}
            style={{ backgroundColor: preset.value }}
            data-testid={`${testIdPrefix}-preset-${preset.value.replace('#', '')}`}
          />
        ))}
        {showCustom && (
          <>
            <input
              type="color"
              value={active}
              onChange={(e) => onChange(e.target.value)}
              className="w-6 h-6 rounded cursor-pointer border-2 border-gray-300 p-0"
              title="Custom color"
              data-testid={`${testIdPrefix}-custom-input`}
            />
            <span className="text-[10px] text-muted-foreground">Custom</span>
          </>
        )}
      </div>
    </div>
  );
};

export default GroupColorPicker;
